<script lang="ts" setup>
import { useLayoutPreferencesStore } from '@/stores/layout/layoutPreferences'
import { watch, ref } from 'vue'
import { storeToRefs } from 'pinia'
import Menu from '@/components/navigation/Menu.vue'
import OrganizationSelectorBar from '@/components/navigation/OrganizationSelectorBar.vue'

const layoutPreferencesStore = useLayoutPreferencesStore()
const affix = ref<any>(null)
const { isMenuOpen, isWorkspaceSwitcherEnabled, isOrganizationBarOpen } =
    storeToRefs(layoutPreferencesStore)

watch(isMenuOpen, () => {
    if (affix.value) {
        console.log('Update', affix.value.update)
        //affix.value.update()
        //affix.value.updateRoot()
    }
})
</script>

<template>
    <!--:style="{width:isMenuOpen ? '600px' : '124px'}"-->
    <!--:style="{ width: isMenuOpen ? '280px' : '124px' }" -->
    <el-aside
        class="sidebar"
        :class="{
            open: isMenuOpen,
            closed: !isMenuOpen,
            workspaceSwitcher: isWorkspaceSwitcherEnabled
        }"
    >
        <el-affix ref="affix" :offset="1" target="#app" :class="isMenuOpen ? 'open' : 'closed'">
            <div class="sidebar-wrapper">
                <OrganizationSelectorBar
                    v-if="isWorkspaceSwitcherEnabled && isOrganizationBarOpen"
                />

                <Menu />
            </div>
        </el-affix>
    </el-aside>
</template>

<style lang="scss" scoped>
.sidebar {
    transition-property: max-width;
    transition-duration: 0.3s;
    transition-delay: 0s;
    background-color: var(--el-menu-bg-color);

    &.open {
        max-width: 240px;
    }

    &.open.workspaceSwitcher {
        max-width: 300px !important;
    }

    &.closed {
        max-width: 64px;
    }
    &.closed.workspaceSwitcher {
        max-width: 124px !important;
    }

    .el-affix {
        &.open {
            width: 300px !important;
        }

        &.closed {
            width: 124px !important;
        }
    }

    //position: fixed;
    //top: 0px;
    //left: 0px;

    .sidebar-wrapper {
        display: flex;
    }
}
</style>
